<section class="mobile-banner-holder d-block d-md-none" *ngIf="mobileBannerConfig && !hideMobileScreen">
    <span class="close-button-holder">
        <serviceos-ng-system-icon (click)="close()" class="close" [icon]="'close-cancel'"></serviceos-ng-system-icon>
    </span>
    <div class="banner-box" [style.background-image]="'url(' + mobileBannerConfig.banner_background_url + ')'">
        <div class="content-holder" *ngIf="mobileBannerConfig.content" [innerHTML]="mobileBannerConfig.content"></div>
        <div class="buttons-holder" *ngIf="mobileBannerConfig.confirm_button && mobileBannerConfig.cancel_button">
            <a href="{{ mobileBannerConfig.confirm_button.url }}">
                <serviceos-ng-button
                    [type]="'primary'"
                    >{{ mobileBannerConfig.confirm_button.title }}
                </serviceos-ng-button>
            </a>
            <serviceos-ng-button
                (click)="close()"
                [type]="'tertiary'"
                >{{ mobileBannerConfig.cancel_button.title }}
            </serviceos-ng-button>
        </div>
    </div>
</section>